"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var RawExampleDrawer_1 = require("./RawExampleDrawer");
var StylingExampleDrawer_1 = require("./StylingExampleDrawer");
exports.ComponentDrawerPage = function () { return (React.createElement(common_1.Page, { headerText: "Drawer" },
    React.createElement(common_1.Paragraph, null, "Drawer is a sidebar normally used to navigation."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(RawExampleDrawer_1.RawExampleDrawer, null),
    React.createElement(StylingExampleDrawer_1.StylingExampleDrawer, null))); };
exports.ComponentDrawerPage.displayName = 'ComponentDrawerPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerPage/ComponentDrawerPage.tsx
// module id = 659
// module chunks = 0